import { useFormikContext } from 'formik';
import React, { useEffect } from 'react';

interface OptionalFormFieldProps {
  children: React.ReactNode;
  conditionKey: string;
  conditionValue: boolean | string | string[];
  resetField?: string;
  negate?: boolean;
}

const OptionalFormField: React.FC<OptionalFormFieldProps> = ({
  children,
  conditionKey,
  conditionValue,
  resetField,
  negate = false,
}) => {
  const { values, setFieldValue } = useFormikContext<any>();
  let condition: boolean;

  if (Array.isArray(conditionValue)) {
    const value = String(values[conditionKey]);
    condition = conditionValue.includes(value);
  } else {
    condition = values[conditionKey] === conditionValue;
  }

  if (negate) {
    condition = !condition;
  }

  useEffect(() => {
    if (resetField && !condition) {
      setFieldValue(resetField, '');
    }
  }, [condition, resetField, setFieldValue]);

  return <>{condition && children}</>;
};

export default OptionalFormField;
